export default {
    logoAlt: 'VR实验室标识',
    brand: {
      title: 'VR实验室',
      tagline: '暨南大学',
    },
    nav: [
      { to: '/', label: '首页' },
      { to: '/members', label: '成员' },
      { to: '/publications', label: '成果' },
      { to: '/teaching', label: '教学' },
      { to: '/opening', label: '开放信息' },
    ],
    language: {
      label: '语言',
      trigger: '中文',
      options: {
        en: 'English',
        zh: '中文',
      },
    },
    mobileMenu: {
      open: '展开导航菜单',
      close: '关闭导航菜单',
      label: '主要导航',
    },
    footer: '版权所有 © {year} 暨南大学 VR实验室',
  };
